/*eslint-disable*/
import { Field } from 'Util/Query';

/**
 * PopularCategoryQuery Query
 * @class PopularCategoryQuery
 * @namespace Query/PopularCategoryQuery
 */
export class PopularCategoryQuery {
    getQuery() {
        return new Field('popularCategory')
            .addFieldList(this._getPopularCategoryFields())
            .setAlias('popularCategories');
    }
    _getPopularCategoryFields() {
        return [
            this._getPopularCategoryField(),        
            'title'
        ];
    }

    _getCategoryFields() {
        return [
            'name',
            'url',
            'image',          
            'id'
        ];
    }

    _getPopularCategoryField() {
        return new Field('popularCategories')
            .addFieldList(this._getCategoryFields());
    }
}

export default new PopularCategoryQuery();
